import { render } from "./tea.vue?vue&type=template&id=61819c7e"
import script from "./tea.vue?vue&type=script&lang=js"
export * from "./tea.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__